export default __webpack_public_path__ + "static/media/IMG4114.baacc5d1.jpg";